import {
  getListadoPlanesMovilidadAPI,
  crearPlanMovilidadAPI,
  getEstadisticasPlanMovilidadAPI,
  editarPlanMovilidadAPI,
  getListadoMedidasPorPlanMovilidadAPI,
  getListadoSubMedidasPorPlanMovilidadAPI,
  getListadoSubMedidasPorMedidaAPI,
  getListadoTareasPorSubMedidaAPI,
  escogerTiposUsuariosRiesgosPlanMovilidadAPI,
  calcularMedidasSubmedidasTareasPlanMovilidadAPI,
  obtenerDocumentoCombinacionPlanMovilidadAPI,
  editarSubMedidaPlanMovilidadAPI,
  editarSubMedidaTareaSeguimientoAPI,
  getListadoContenidosCompletoAPI,
  getListadoContenidosPorSeccionEtapaAPI,
  getAccidentesListAPI,
  createEditAccidenteDataAPI,
  getEmplyeesByCompanyRutAPI,
  getCountEmployeesByRutAPI
} from "./api";

import error from "../config/mensajesError";
import { compareDateToday, generaSubMedidasAprobadas, dataLayerTag } from "./functions";

// archivos descargables
import Medidas_1_4_5_6_7 from "../Descargable/Medidas_1_4_5_6_7.pdf";
import Medidas_1_4_5_6_8 from "../Descargable/Medidas_1_4_5_6_8.pdf";
import Medidas_1_4_5_6 from "../Descargable/Medidas_1_4_5_6.pdf";
import Medidas_2_4_5_6_7 from "../Descargable/Medidas_2_4_5_6_7.pdf";
import Medidas_2_4_5_6_8 from "../Descargable/Medidas_2_4_5_6_8.pdf";
import Medidas_2_4_5_6 from "../Descargable/Medidas_2_4_5_6.pdf";
import Medidas_3_4_5_6_7 from "../Descargable/Medidas_3_4_5_6_7.pdf";
import Medidas_3_4_5_6_8 from "../Descargable/Medidas_3_4_5_6_8.pdf";
import Medidas_3_4_5_6 from "../Descargable/Medidas_3_4_5_6.pdf";

const erroresServicios = code => {
  switch (code) {
    case 400: return error.E400;
    case 403: return error.E403;
    case 404: return error.E404;
    case 500: return error.E500;
    case 504: return error.E504;
    case 509: return error.E509;
    default: return error.otro;
  }
}

export const loadEtapas = (etapaTabs, estadoProceso) => ({
  type: "LOAD_ETAPA_PLANMOVILIDAD",
  etapaTabs,
  estadoProceso,
});

export const changeEtapas = (newEtapaPosition) => ({
  type: "CHANGE_ETAPA_PLANMOVILIDAD",
  newEtapaPosition,
});

export const loadSubMenu = (subMenuTabs, subMenuPosition) => ({
  type: "LOAD_SUBMENU_PLANMOVILIDAD",
  subMenuTabs,
  subMenuPosition,
});


export const changeSubMenu = (newSubMenuPosition) => ({
  type: "CHANGE_SUBMENU_PLANMOVILIDAD",
  newSubMenuPosition,
});

export const isLoadingPlanMovilidad = (isLoading) => ({
  type: "LOADING_PLANMOVILIDAD",
  isLoading,
});

export const getListadoPlanesMovilidad = (idempresa, idcentro, rutusuario) => async (dispatch) => {
  try {
    const request = await getListadoPlanesMovilidadAPI(idempresa, idcentro);
    if (request.status === 200) {
      const result = await request.json();
      if (result.resultadoOperacion.operationCode === 1) {
        dispatch(handlerListadoPlanesMovilidad(result));
        dispatch(getEncargadoPlanMovilidad(rutusuario, result));
      } else {
        dispatch(onAlertaPlanMovilidad("error", `Error con la carga de los planes: ${result.resultadoOperacion.operationMessage}`));
      }
    } else {
      dispatch (onAlertaPlanMovilidad("error",erroresServicios(request.status)));
    }
  } catch (error) {
    console.log(`Error en [getListadoPlanesMovilidadAPI]: ${error}`);
  }
  dispatch(isLoadingPlanMovilidad(false));
};

const getEncargadoPlanMovilidad = (rutusuario, result) => ({
  type: "GET_ENCARGADO_PLAN_MOVILIDAD",
  rutusuario,
  result,
});

const handlerListadoPlanesMovilidad = (result) => ({
  type: "HANDLER_LISTADO_PLANES_MOVILIDAD",
  result,
});

export const crearPlanMovilidad = (idempresa, nombreEmpresa, idcentro, nombreCentro, rutusuario, nombre, apellido, email) => async (dispatch) => {
  dispatch(isLoadingPlanMovilidad(true));
  try {
    const request = await crearPlanMovilidadAPI(idempresa, nombreEmpresa, idcentro, nombreCentro, rutusuario, nombre, apellido, email);
    if (request.status === 200) {
      const result = await request.json();
      if (result.resultadoOperacion.operationCode === 1) {
        dispatch(limpiarPlanMovilidad());
        dispatch(handlerCrearPlanMovilidad(result));
        // GTM
        dataLayerTag({
          'event': 'etapa_1_llegada',
          'etapa': '1'
        });
        // soy el encargado porque yo creé el plan
        dispatch(changeEncargadoPlan(true));
      } else {
        dispatch(onAlertaPlanMovilidad("error", `Error al crear el plan de movilidad: ${result.resultadoOperacion.operationMessage}`));
      }
    } else {
      dispatch (onAlertaPlanMovilidad("error",erroresServicios(request.status)));
    }
  } catch (error) {
    console.log(`Error en [crearPlanMovilidadAPI]: ${error}`);
  }
  dispatch(isLoadingPlanMovilidad(false));
};

const handlerCrearPlanMovilidad = (result) => ({
  type: "CREAR_PLAN_MOVILIDAD",
  result,
});

export const getEstadisticasPlanMovilidad = (idempresa, idcentro, rutusuario) => async (dispatch) => {
  dispatch(isLoadingPlanMovilidad(true));
  try {
    const request = await getEstadisticasPlanMovilidadAPI(idempresa, idcentro, rutusuario);
    if (request.status === 200) {
      const result = await request.json();
      if (result.resultadoOperacion.operationCode === 1) {
        dispatch(handlerEstadisticasPlanMovilidad(result));
      } else {
        dispatch(onAlertaPlanMovilidad("error", `Error con la obtención de estadisticas: ${result.resultadoOperacion.operationMessage}`));
      }
    } else {
      dispatch (onAlertaPlanMovilidad("error",erroresServicios(request.status)));
    }
  } catch (error) {
    console.log(`Error en [getEstadisticasPlanMovilidadAPI]: ${error}`);
  }
};

const handlerEstadisticasPlanMovilidad = (result) => ({
  type: "HANDLER_ESTADISTICAS_PLAN_MOVILIDAD",
  result,
});

// solo para el cambio de estado
export const editarPlanMovilidad = (idplanMovilidad, estadoPlan, estadoEjecucion, estadoProceso, subMenuPosition) => async (dispatch) => {
  dispatch(isLoadingPlanMovilidad(true));
  try {
    const request = await editarPlanMovilidadAPI(idplanMovilidad, estadoPlan, estadoEjecucion, estadoProceso);
    if (request.status === 200) {
      const result = await request.json();
      if (result.resultadoOperacion.operationCode === 1) {
        dispatch(limpiarPlanMovilidad());
        dispatch(handlerEditarPlanMovilidad(result));
        // debo saber si soy el encargado?
        dispatch(changeEncargadoPlan(true));
      } else {
        dispatch(onAlertaPlanMovilidad("error", `Error al modificar el plan de movilidad: ${result.resultadoOperacion.operationMessage}`));
      }
    } else {
      dispatch (onAlertaPlanMovilidad("error",erroresServicios(request.status)));
    }
  } catch (error) {
    console.log(`Error en [editarPlanMovilidadAPI] en editarPlanMovilidad: ${error}`);
  }
  dispatch(isLoadingPlanMovilidad(false));
  // redirecciono a la posición de finalizar
  dispatch(changeSubMenu(subMenuPosition));
};

const handlerEditarPlanMovilidad = (result) => ({
  type: "HANDLER_EDITAR_PLAN_MOVILIDAD",
  result,
});

export const changeFlagCargaInicial = (flag) => ({
  type: "CHANGE_FLAG_CARGA_INICIAL_PLAN_MOVILIDAD",
  flag,
});

export const editarPlanMovilidadEncuesta = (idplanMovilidad, habilitarTokenEncuesta, cantidadHombresCentro, cantidadMujeresCentro, fechaCierreEncuestaTrabajador) => async (dispatch) => {
  dispatch(isLoadingPlanMovilidad(true));
  try {
    const request = await editarPlanMovilidadAPI(idplanMovilidad, 0, 0, 0, habilitarTokenEncuesta, cantidadHombresCentro, cantidadMujeresCentro, fechaCierreEncuestaTrabajador);
    if (request.status === 200) {
      const result = await request.json();
      if (result.resultadoOperacion.operationCode === 1) {
        dispatch(handlerEditarPlanMovilidad(result));
        dispatch(changeEncargadoPlan(true));
      } else {
        dispatch(onAlertaPlanMovilidad("error", `Error al modificar el plan de movilidad: ${result.resultadoOperacion.operationMessage}`));
      }
    } else {
      dispatch (onAlertaPlanMovilidad("error",erroresServicios(request.status)));
    }
  } catch (error) {
    console.log(`Error en [editarPlanMovilidadAPI] en editarPlanMovilidadEncuesta: ${error}`);
  }
  dispatch(isLoadingPlanMovilidad(false));
};

export const editarPlanMovilidadEncargado = (idplanMovilidad, Rutusuario, nombre, mirutusuario, email) => async (dispatch) => {
  dispatch(isLoadingPlanMovilidad(true));
  try {
    const request = await editarPlanMovilidadAPI(idplanMovilidad, 0, 0, 0, null, null, null, null, Rutusuario, nombre, '', email);
    if (request.status === 200) {
      const result = await request.json();
      if (result.resultadoOperacion.operationCode === 1) {
        dispatch(limpiarPlanMovilidad());
        dispatch(handlerEditarPlanMovilidad(result));
        //dispatch(getEncargadoPlanMovilidad(mirutusuario, Rutusuario));
        dispatch(getEncargadoPlanMovilidad(mirutusuario, result));
        dispatch(onAlertaPlanMovilidad("success", `Se definió a ${nombre} como encargado del plan de movilidad.`));
      } else {
        dispatch(onAlertaPlanMovilidad("error", `Error al modificar el plan de movilidad: ${result.resultadoOperacion.operationMessage}`));
      }
    } else {
      dispatch (onAlertaPlanMovilidad("error",erroresServicios(request.status)));
    }
  } catch (error) {
    console.log(`Error en [editarPlanMovilidadAPI] en editarPlanMovilidadEncargado: ${error}`);
  }
  dispatch(isLoadingPlanMovilidad(false));
};

export const getListadoMedidasPorPlanMovilidad = (idPlanMovilidad) => async (dispatch) => {
  dispatch(handlerMedidasLoading(true));
  try {
    const request = await getListadoMedidasPorPlanMovilidadAPI(idPlanMovilidad);
    if (request.status === 200) {
      const result = await request.json();
      if (result.resultadoOperacion.operationCode === 1) {
        dispatch(handlerGetListadoMedidasPorPlanMovilidad(result.medidasPlanMovilidad));
      } else {
        dispatch(onAlertaPlanMovilidad("error", `Error al obtener el listado de medidas por plan de movilidad: ${result.resultadoOperacion.operationMessage}`));
      }
    } else {
      dispatch (onAlertaPlanMovilidad("error",erroresServicios(request.status)));
    }
  } catch (error) {
    console.log(`Error en [getListadoMedidasPorPlanMovilidadAPI]: ${error}`);
  }
  dispatch(handlerMedidasLoading(false));
};

const handlerGetListadoMedidasPorPlanMovilidad = (medidasPlanMovilidad) => ({
  type: "HANDLER_LISTADO_MEDIDAS_PLAN_MOVILIDAD",
  medidasPlanMovilidad,
});

export const handlerMedidasLoading = (isMedidasLoading) => ({
  type: "HANDLER_MEDIDAS_LOADING",
  isMedidasLoading,
});

export const getListadoSubMedidasPorPlanMovilidad = (idPlanMovilidad) => async (dispatch) => {
  dispatch(handlerSubMedidasLoading(true));
  try {
    const request = await getListadoSubMedidasPorPlanMovilidadAPI(idPlanMovilidad);
    if (request.status === 200) {
      const result = await request.json();
      if (result.resultadoOperacion.operationCode === 1) {
        dispatch(handlerGetListadoSubMedidasPorPlanMovilidad(result.subMedidasPlanesMovilidad));
      } else {
        dispatch(onAlertaPlanMovilidad("error", `Error al obtener el listado de acciones por plan de movilidad: ${result.resultadoOperacion.operationMessage}`));
      }
    } else {
      dispatch (onAlertaPlanMovilidad("error",erroresServicios(request.status)));
    }
  } catch (error) {
    console.log(`Error en [getListadoSubMedidasPorPlanMovilidadAPI]: ${error}`);
  }
  dispatch(handlerSubMedidasLoading(false));
};

const handlerSubMedidasLoading = (isSubMedidasLoading) => ({
  type: "HANDLER_SUBMEDIDAS_LOADING",
  isSubMedidasLoading,
});

const handlerGetListadoSubMedidasPorPlanMovilidad = (subMedidasPlanesMovilidad) => ({
  type: "HANDLER_LISTADO_SUBMEDIDAS_PLAN_MOVILIDAD",
  subMedidasPlanesMovilidad,
});

export const getListadoSubMedidasPorMedida = (idPlanMovilidadMedida) => async (dispatch) => {
  dispatch(handlerMedidasLoading(true));
  try {
    const request = await getListadoSubMedidasPorMedidaAPI(idPlanMovilidadMedida);
    if (request.status === 200) {
      const result = await request.json();
      if (result.resultadoOperacion.operationCode === 1) {
        dispatch(handlerListadoSubMedidas(idPlanMovilidadMedida, result.subMedidasPlanesMovilidad));
      } else {
        dispatch(onAlertaPlanMovilidad("error", `Error al obtener el listado de acciones por medida: ${result.resultadoOperacion.operationMessage}`));
      }
    } else {
      dispatch (onAlertaPlanMovilidad("error",erroresServicios(request.status)));
    }
  } catch (error) {
    console.log(`Error en [getListadoSubMedidasPorMedidaAPI]: ${error}`);
  }
  dispatch(handlerMedidasLoading(false));
};

const handlerListadoSubMedidas = (idPlanMovilidadMedida, subMedidasPlanesMovilidad) => ({
  type: "HANDLER_PLAN_LISTADO_SUB_MEDIDAS",
  idPlanMovilidadMedida,
  subMedidasPlanesMovilidad,
});

export const getListadoTareasPorSubMedida = (idPlanMovilidadSubMedida) => async (dispatch) => {
  try {
    const request = await getListadoTareasPorSubMedidaAPI(idPlanMovilidadSubMedida);
    if (request.status === 200) {
      const result = await request.json();
      if (result.resultadoOperacion.operationCode === 1) {
        // console.log(result);
      } else {
        dispatch(onAlertaPlanMovilidad("error", `Error al obtener el listado de tareas por accion: ${result.resultadoOperacion.operationMessage}`));
      }
    } else {
      dispatch (onAlertaPlanMovilidad("error",erroresServicios(request.status)));
    }
  } catch (error) {
    console.log(`Error en [getListadoTareasPorSubMedidaAPI]: ${error}`);
  }
};

export const escogerTiposUsuariosRiesgosPlanMovilidad = (idPlanMovilidad) => async (dispatch) => {
  try {
    const request = await escogerTiposUsuariosRiesgosPlanMovilidadAPI(idPlanMovilidad);
    if (request.status === 200) {
      const result = await request.json();
      if (result.operationCode === 1) {
        dispatch(onAlertaPlanMovilidad("success", result.operationMessage));
      } else {
        dispatch(onAlertaPlanMovilidad("error", `Error al obtener el listado de tareas por accion: ${result.operationMessage}`));
      }
    } else {
      dispatch (onAlertaPlanMovilidad("error",erroresServicios(request.status)));
    }
  } catch (error) {
    console.log(`Error en [escogerTiposUsuariosRiesgosPlanMovilidadAPI]: ${error}`);
  }
};


export const calcularMedidasSubmedidasTareasPlanMovilidad = (idPlanMovilidad) => async (dispatch) => {
  try {
    const request = await calcularMedidasSubmedidasTareasPlanMovilidadAPI(idPlanMovilidad);
    if (request.status === 200) {
      const result = await request.json();
      if (result.resultadoOperacion.operationCode === 1) {
        dispatch(handlerGetListadoMedidasPorPlanMovilidad(result.medidasPlanMovilidad));
        dispatch(onAlertaPlanMovilidad("success", result.resultadoOperacion.operationMessage));
      } else {
        dispatch(onAlertaPlanMovilidad("error", `Error al obtener el listado de tareas por acción: ${result.operationMessage}`));
      }
    } else {
      dispatch (onAlertaPlanMovilidad("error",erroresServicios(request.status)));
    }
  } catch (error) {
    console.log(`Error en [calcularMedidasSubmedidasTareasPlanMovilidadAPI]: ${error}`);
  }
  dispatch(handlerGeneracionMedidas(true));
};

const handlerGeneracionMedidas = (medidasGeneradas) => ({
  type: "HANDLER_GENERACION_MEDIDAS",
  medidasGeneradas,
});

export const obtenerDocumentoCombinacionPlanMovilidad = (idPlanMovilidad) => async (dispatch) => {
  dispatch(handlerObtenerDocumento(true));
  try {
    const request = await obtenerDocumentoCombinacionPlanMovilidadAPI(idPlanMovilidad);
    if (request.status === 200) {
      const result = await request.json();
      if (result.resultadoOperacion.operationCode === 1) {
        let nombre = result.combinacionPlanDocumento.descripcion.split(" ");
        let medidas = [];
        for( let i=0; i<nombre.length; i++){
          if (nombre[i] >= '1' && nombre[i] <= '9'){
            medidas = medidas.concat(nombre[i][0]);
          }
        }
        let joinMedidas = medidas.join('_');
        const files = [
          {file: Medidas_1_4_5_6_7, code: '1_4_5_6_7'},
          {file: Medidas_1_4_5_6_8, code: '1_4_5_6_8'},
          {file: Medidas_1_4_5_6, code: '1_4_5_6'},
          {file: Medidas_2_4_5_6_7, code: '2_4_5_6_7'},
          {file: Medidas_2_4_5_6_8, code: '2_4_5_6_8'},
          {file: Medidas_2_4_5_6, code: '2_4_5_6'},
          {file: Medidas_3_4_5_6_7, code: '3_4_5_6_7'},
          {file: Medidas_3_4_5_6_8, code: '3_4_5_6_8'},
          {file: Medidas_3_4_5_6, code: '3_4_5_6'}
        ];
        for (let j=0; j<files.length; j++){
          if (joinMedidas === files[j].code){
            window.open(files[j].file,'_blank');
            break;
          }
        }
      } else {
        dispatch(onAlertaPlanMovilidad("error", `Error en la obtención del archivo: ${result.resultadoOperacion.operationMessage}`));
      }
    } else {
      dispatch (onAlertaPlanMovilidad("error",erroresServicios(request.status)));
    }
  } catch (error) {
    console.log(`Error en [obtenerDocumentoCombinacionPlanMovilidadAPI]: ${error}`);
  }
  dispatch(handlerObtenerDocumento(false));
};

const handlerObtenerDocumento = (isLoadingDocumento) => ({
  type: "HANDLER_OBTENER_DOCUMENTO",
  isLoadingDocumento,
});

export const handlerTokenEncuesta = (habilitarTokenEncuesta) => ({
  type: "HANDLER_TOKEN_ENCUESTA",
  habilitarTokenEncuesta,
});

export const handlerEstadoProcesoPlanMovilidad = (estadoProceso) => ({
  type: "HANDLER_ESTADO_PROCESO",
  estadoProceso,
});

export const openCloseModalSubMedida = (isOpenSubMedidaModal, dataSubMedidaModal) => ({
  type: "OPEN_CLOSE_MODAL_EDITAR_SUBMEDIDA",
  isOpenSubMedidaModal,
  dataSubMedidaModal,
});

export const loadingModalSubMedida = (isLoadingSubMedidaModal) => ({
  type: "LOADING_MODAL_EDITAR_SUBMEDIDA",
  isLoadingSubMedidaModal,
});

export const editarSubMedidaPlanMovilidad = (idplanSubMedida, subMedidaElegida, fechaInicio, fechaLimite) => async (dispatch) => {
  dispatch(handlerMedidasLoading(true));
  try {
    const request = await editarSubMedidaPlanMovilidadAPI(idplanSubMedida, subMedidaElegida, fechaInicio, fechaLimite);
    if (request.status === 200) {
      const result = await request.json();
      if (result.resultadoOperacion.operationCode === 1) {
        dispatch(getListadoSubMedidasPorMedida(result.subMedida.idplanMedida));
        dispatch(onAlertaPlanMovilidad("success", `La acción "${result.subMedida.descripcion}" fue editada exitosamente.`));
      } else {
        dispatch(onAlertaPlanMovilidad("error", `Error en la edición de la acción por Plan de Movilidad: ${result.resultadoOperacion.operationMessage}`));
      }
    } else {
      dispatch (onAlertaPlanMovilidad("error",erroresServicios(request.status)));
    }
  } catch (error) {
    console.log(`Error en [editarSubMedidaPlanMovilidadAPI]: ${error}`);
  }
};

export const limpiarPlanMovilidad = () => ({
  type: "LIMPIAR_PLAN_MOVILIDAD",
});

export const openCloseModalEncuestaTrabajadores = (isOpenEncuestaModal, dataEncuestaModal) => ({
  type: "OPEN_CLOSE_MODAL_TRABAJADORES",
  isOpenEncuestaModal,
  dataEncuestaModal,
});


export const checkMedidasValue = (idPlanMovilidad) => async (dispatch) => {
  dispatch(handlerMedidasLoading(true));
  try {
    const request = await getListadoMedidasPorPlanMovilidadAPI(idPlanMovilidad);
    if (request.status === 200) {
      const result = await request.json();
      if (result.resultadoOperacion.operationCode === 1) {
        // aquí ya tengo mis medidas fresquitas...
        const medidas = result.medidasPlanMovilidad;
        let medida = null;
        let subMedidasAprobadas = 0;
        let subMedidasFechaErronea = 0;
        let cambioEstado = true;
        const nombreAcciones = [];
        for (let i = 0; i < medidas.length; i++) {
          medida = medidas[i];
          for (let j = 0; j < medida.tblPlanSubMedida.length; j++) {
            // verifico si están habilitadas
            if (medida.tblPlanSubMedida[j].subMedidaElegida) {
              subMedidasAprobadas++;
            }
            // verifico las fechas antes de hoy
            if (compareDateToday(medida.tblPlanSubMedida[j].fechaInicio) === -1 && medida.tblPlanSubMedida[j].subMedidaElegida) {
              subMedidasFechaErronea++;
            }

            // hago el arreglo para la distribución del dataLayer
            for(let k = 0; k < medida.tblPlanSubMedida[j].tblPlanSubMedidaTarea.length; k+=1){
              nombreAcciones.push(medida.tblPlanSubMedida[j].tblPlanSubMedidaTarea[k].descripcion);
            }
          }
          if (subMedidasAprobadas === 0) {
            dispatch(onAlertaPlanMovilidad("error", "Existen medidas que no tienen acciones habilitadas, revise las acciones."));
            cambioEstado = false;
            break;
          }
          if (subMedidasFechaErronea !== 0) {
            dispatch(onAlertaPlanMovilidad("error", "Hay problemas con fechas de Inicio, revise las acciones."));
            cambioEstado = false;
            break;
          }
          subMedidasAprobadas = 0;
          subMedidasFechaErronea = 0;
        }
        if (cambioEstado) {
          // manejo la información del cambio de estado
          dispatch(handlerEstadoProcesoPlanMovilidad(4));
          dispatch(editarPlanMovilidad(
            idPlanMovilidad,
            1, // this.props.estadoPlan, -> plan a Aprobado
            2, // this.props.estadoEjecucion -> plan a Ejecución
            4, // this.props.estadoProceso, -> plan en etapa de monitoreo
            2, // paso a pestaña finalizar
          ));
          //gtd -> finalizo etapa 3 (configuracion)
          dataLayerTag({
            'event': 'etapa_3_finalizar ',
            'etapa': '3',
            'acciones_checkeadas': nombreAcciones,
          });
          // gtd -> inicio etapa 4 (seguimiento)
          dataLayerTag({
            'event': 'etapa_4_llegada',
            'etapa': '4',
            'acciones_checkeadas': nombreAcciones,
          });
        }
      } else {
        dispatch(onAlertaPlanMovilidad("error", `Error al revisar las medidas: ${result.resultadoOperacion.operationMessage}`));
      }
    } else {
      dispatch (onAlertaPlanMovilidad("error",erroresServicios(request.status)));
    }
  } catch (error) {
    console.log(`Error en [getListadoMedidasPorPlanMovilidadAPI]: ${error}`);
  }
  dispatch(handlerMedidasLoading(false));
};

export const onAlertaPlanMovilidad = (alertaCode, alertaMensaje) => ({
  type: "ON_ALERTA_PLAN_MOVILIDAD",
  alertaCode,
  alertaMensaje,
});

export const offAlertaPlanMovilidad = () => ({
  type: "OFF_ALERTA_PLAN_MOVILIDAD",
});

export const getListadoMedidasAprobadas = (idPlanMovilidad) => async (dispatch) => {
  dispatch(handlerMedidasLoading(true));
  try {
    const request = await getListadoMedidasPorPlanMovilidadAPI(idPlanMovilidad);
    if (request.status === 200) {
      const result = await request.json();
      if (result.resultadoOperacion.operationCode === 1) {
        dispatch(handlerGetListadoMedidasPorPlanMovilidad(generaSubMedidasAprobadas(result.medidasPlanMovilidad)));
      } else {
        dispatch(onAlertaPlanMovilidad("error", `Error al obtener el listado de medidas aprobadas por plan de movilidad: ${result.resultadoOperacion.operationMessage}`));
      }
    } else {
      dispatch (onAlertaPlanMovilidad("error",erroresServicios(request.status)));
    }
  } catch (error) {
    console.log(`Error en [getListadoMedidasPorPlanMovilidadAPI]: ${error}`);
  }
  dispatch(handlerMedidasLoading(false));
};

export const editarSubMedidaTareaSeguimiento = (idPlanMovilidad, idplanSubMedida, estadoSubMedida, totalEntrega, totalObjetivo, tblPlanSubMedidaTarea, fechaInicio, fechaLimite) => async (dispatch) => {
  try {
    const request = await editarSubMedidaTareaSeguimientoAPI(idplanSubMedida, totalEntrega, estadoSubMedida, totalObjetivo, tblPlanSubMedidaTarea, fechaInicio, fechaLimite);
    if (request.status === 200) {
      const result = await request.json();
      if (result.resultadoOperacion.operationCode === 1) {
        dispatch(getListadoMedidasAprobadas(idPlanMovilidad));
        //dispatch(onAlertaPlanMovilidad("success", result.resultadoOperacion.operationMessage));
        dispatch(onAlertaPlanMovilidad("success", "La acción fue editada con éxito."));
      } else {
        dispatch(onAlertaPlanMovilidad("error", `Error al editar la acción, compruebe la información: ${result.resultadoOperacion.operationMessage}`));
      }
    } else {
      dispatch (onAlertaPlanMovilidad("error",erroresServicios(request.status)));
    }
  } catch (error) {
    console.log(`Error en [editarSubMedidaTareaSeguimientoAPI]: ${error}`);
  }
};

export const finalizarPlanMovilidad = (idPlanMovilidad) => async (dispatch) => {
  dispatch(handlerMedidasLoading(true));
  try {
    const request = await getListadoMedidasPorPlanMovilidadAPI(idPlanMovilidad);
    if (request.status === 200) {
      const result = await request.json();
      if (result.resultadoOperacion.operationCode === 1) {
        // aquí ya tengo mis medidas fresquitas...
        let cambioEstado = true;
        const medidas = result.medidasPlanMovilidad;
        const nombreAcciones = [];
        let accionesFinalizadas = 0;
        // reviso que todas mis submedidas estén en estado 1 (estadoSubMedida)
        for (let i in medidas){
          const { tblPlanSubMedida } = medidas[i];
          for (let j in tblPlanSubMedida){
            const {estadoSubMedida, subMedidaElegida, tblPlanSubMedidaTarea} = tblPlanSubMedida[j];
            if (estadoSubMedida !== 1 && subMedidaElegida) {
              cambioEstado = false;
              break;
            }
            // hago el cálculo de las acciones para el dataLayer
            for (let k in tblPlanSubMedidaTarea){
              nombreAcciones.push(tblPlanSubMedidaTarea[k].descripcion);
              if (tblPlanSubMedidaTarea[k].completada){
                accionesFinalizadas+=1;
              }
            }
          }
          // verifico si la medida está finalizada
          if (medidas[i].estadoMedida !== 1) {
            cambioEstado = false;
            break;
          }
        }
        if (cambioEstado) {
          dispatch(handlerEstadoProcesoPlanMovilidad(0));
          dispatch(editarPlanMovilidad(
            idPlanMovilidad,
            1, // this.props.estadoPlan, -> plan a Aprobado
            1, // this.props.estadoEjecucion -> plan a Ejecución
            4, // this.props.estadoProceso, -> plan en etapa de monitoreo
            3, // paso a pestaña finalizar
          ));
          // gtd -> finalizar plan de movilidad
          dataLayerTag({
            'event': 'etapa_4_finalizar',
            'etapa': '4',
            'acciones_checkeadas': nombreAcciones,
            'acciones_finalizadas': accionesFinalizadas,  //numero de acciones finalizadas
            'total_medidas': medidas.length, // numero total de medidas.
           
          });
        } else {
          dispatch(onAlertaPlanMovilidad("error", "Hay medidas que no han sido finalizadas."));
        }
      } else {
        dispatch(onAlertaPlanMovilidad("error", `Error al revisar las medidas: ${result.resultadoOperacion.operationMessage}`));
      }
    } else {
      dispatch (onAlertaPlanMovilidad("error",erroresServicios(request.status)));
    }
  } catch (error) {
    console.log(`Error en [getListadoMedidasPorPlanMovilidadAPI]: ${error}`);
  }
  dispatch(handlerMedidasLoading(false));
};

export const getListadoContenidosPorSeccionEtapa = (tipoSeccion, tipoEtapa) => async (dispatch) => {
  try {
    const request = await getListadoContenidosPorSeccionEtapaAPI(tipoSeccion, tipoEtapa);
    if (request.status === 200) {
      const result = await request.json();
      if (result.resultadoOperacion.operationCode === 1) {
        dispatch(handlerContenidos(result.contenidosList));
      } else {
        dispatch(onAlertaPlanMovilidad("error", `Error con la carga del contenido para ${tipoSeccion}`));
      }
    } else {
      dispatch (onAlertaPlanMovilidad("error",erroresServicios(request.status)));
    }
  } catch (error) {
    console.log(`Error en [getListadoContenidosPorSeccionEtapaAPI]: ${error}`);
  }
};

export const getListadoContenidosCompleto = () => async (dispatch) => {
  try {
    const request = await getListadoContenidosCompletoAPI();
    if (request.status === 200) {
      const result = await request.json();
      if (result.resultadoOperacion.operationCode === 1) {
        dispatch(handlerContenidos(result.contenidosList));
      } else {
        dispatch(onAlertaPlanMovilidad("error", "Error con la carga del contenido"));
      }
    } else {
      dispatch (onAlertaPlanMovilidad("error",erroresServicios(request.status)));
    }
  } catch (error) {
    console.log(`Error en [getListadoContenidosCompletoAPI]: ${error}`);
  }
};

const handlerContenidos = (listaContenidos) => ({
  type: "HANDLER_CONTENIDOS_PLAN_MOVILIDAD",
  listaContenidos,
});

export const getAccidentesList = (idEmpresa, idCentro) => async (dispatch) => {
  dispatch(isLoadingAccidentes(true));
  try {
    const request = await getAccidentesListAPI(idEmpresa, idCentro);
    if (request.status === 200) {
      const result = await request.json();
      if (result.resultadoOperacion.operationCode === 0) {
        dispatch(handlerAccidentes(result.listadoSiniestros));
      } else {
        dispatch(onAlertaPlanMovilidad("error", "Error con la carga la lista de siniestros."));
      }
    } else {
      dispatch (onAlertaPlanMovilidad("error",erroresServicios(request.status)));
    }
  } catch (error) {
    console.log(`Error en [getAccidentesListAPI]: ${error}`);
  }
  dispatch(isLoadingAccidentes(false));
};

export const createEditAccidenteData = (idsiniestro, idcentro, idempresa, ruttrabajador, nombreTrabajador, fpresentacion, fsiniestro, existeDB, medioTransporte, tipoAccidente) => async (dispatch) => {
  dispatch(isLoadingAccidentes(true));
  try {
    let request = null;
    if (!existeDB){
      request = await createEditAccidenteDataAPI(idsiniestro, idcentro, idempresa, ruttrabajador, nombreTrabajador, fpresentacion, fsiniestro, medioTransporte, tipoAccidente);
    } else {
      request = await createEditAccidenteDataAPI(idsiniestro, idcentro, idempresa, null, null, null, null, medioTransporte, tipoAccidente);
    }
    if (request.status === 200) {
      const result = await request.json();
      if (result.resultadoOperacion.operationCode === 1) {
        dispatch(handlerAccidentes(result.listadoSiniestros));
        dispatch(onAlertaPlanMovilidad("success",result.resultadoOperacion.operationMessage));
      } else {
        dispatch(onAlertaPlanMovilidad("error", "Error al registrar un siniestro."));
      }
    } else {
      dispatch (onAlertaPlanMovilidad("error",erroresServicios(request.status)));
    }
  } catch (error) {
    console.log(`Error en [createEditAccidenteDataAPI]: ${error}`);
  }
  dispatch(isLoadingAccidentes(false));
};

const handlerAccidentes = (listadoSiniestros) => ({
  type: "HANDLER_ACCIDENTES_PLAN_MOVILIDAD",
  listadoSiniestros,
});

const isLoadingAccidentes = (isLoadingSiniestros) => ({
  type: "HANDLER_LOADING_SINIESTROS",
  isLoadingSiniestros,
});

export const getUsersByCompanyId = (idEmpresa) => async(dispatch) => {
  try {
    // hago un doble llamado a la api... 
    // la primera para obtener a la cantidad de usuarios, la segunda para traer los usuarios... 
    const requestCount = await getCountEmployeesByRutAPI(idEmpresa);
    if (requestCount.status === 200){
      const resultCount = await requestCount.json();
      const request = await getEmplyeesByCompanyRutAPI(idEmpresa, resultCount.Count);
      if (request.status === 200) {
        const result = await request.json();
        if (resultCount.Count === result.Dataset.length) {
          dispatch(handlerUsuarios(result.Dataset));
        } else {
          dispatch(onAlertaPlanMovilidad("error", "Ocurrió un error con la obtención de usuarios por compañia."));
        }
      } else {
        dispatch (onAlertaPlanMovilidad("error",erroresServicios(request.status)));
      }
    } else {
      dispatch (onAlertaPlanMovilidad("error",erroresServicios(requestCount.status)));
    }
  } catch (error) {
    console.log(`Error en [getEmplyeesByCompanyRutAPI]: ${error}`);
  }
  dispatch(isLoadingAccidentes(false));

};

const handlerUsuarios = (employees) => ({
  type: "SET_EMPLOYEES_PLANMOVILIDAD",
  employees,
});

const changeEncargadoPlan = (esEncargado) => ({
  type: "CHANGE_ENCARGADO_PLAN_MOVILIDAD",
  esEncargado,
});

// menú inicio
export const loadMenuInicio = (tabs) => ({
  type: "LOAD_INICIOMENU_PLANMOVILIDAD",
  inicioMenuTabs: tabs,
});

export const changeMenuInicio = (position) => ({
  type: "CHANGE_INICIOMENU_PLANMOVILIDAD",
  inicioMenuPosition: position,
});
